import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const anchor = '.js-menu-main-link';
	const subMenu = '.js-submenu';
	const menuItem = '.js-menu-item';

	const menuSelector = '.js-main-menu-desktop';
	const menuElem = document.querySelector(menuSelector);
	const menuMobileSelector = '.js-main-menu-mobile';
	const menuMobileElem = document.querySelector(menuMobileSelector);

	if (!menuElem && !menuMobileElem) {
		return;
	}

	const { MainMenu } = await import('./main-menu');

	if (menuElem) {
		const menu = new MainMenu({
			anchor,
			subMenu,
			menuItem,
			selector: menuSelector,
			elem: menuElem,
		});

		menu.initDesktop();
	}

	if (menuMobileElem) {
		const menu = new MainMenu({
			anchor,
			subMenu,
			menuItem,
			selector: menuMobileSelector,
			elem: menuMobileElem,
		});

		menu.initMobile();
	}
});
